/**
 * Rótulos PT-BR dos defaults canônicos do catálogo de Bonds (ADR-037/131).
 * Valores de wire seguem os enums canônicos; valor desconhecido degrada cru
 * (sem inventar rótulo). Side reusa a semântica das Personas (ADR-041).
 */

const ADVERSARIAL_MODE_LABELS: Record<string, string> = {
  none: 'Sem restrição',
  competitive: 'Competitivo',
  partial: 'Parcial',
  strict: 'Estrito',
};

const SIDE_LABELS: Record<string, string> = {
  seller: 'Empresa',
  buyer: 'Cliente',
  neutral: 'Neutro',
  mediator: 'Mediador',
};

const LIFECYCLE_LABELS: Record<string, string> = {
  'active-closed': 'Ativo → Encerrado',
  'active-paused-closed': 'Ativo → Pausado → Encerrado',
  'enrolled-graduated': 'Matriculado → Formado',
  'in-care-discharged': 'Em cuidado → Alta',
  'in-progress-completed': 'Em andamento → Concluído',
  'listed-sold': 'Anunciado → Vendido',
  'open-resolved-closed': 'Aberto → Resolvido → Encerrado',
};

export function adversarialModeLabel(mode: string): string {
  return ADVERSARIAL_MODE_LABELS[mode] ?? mode;
}

export function bondSideLabel(side: string): string {
  return SIDE_LABELS[side] ?? side;
}

export function bondLifecycleLabel(lifecycle: string): string {
  return LIFECYCLE_LABELS[lifecycle] ?? lifecycle;
}
